const isAbsoluteUrl = (value) => /^https?:\/\//i.test(value);

const hasInlineScheme = (value) =>
  value.startsWith('data:') || value.startsWith('blob:');

export const resolveImageUrl = (rawValue, apiBaseUrl = '') => {
  const value = String(rawValue || '').trim();
  if (!value) return '';

  if (isAbsoluteUrl(value) || hasInlineScheme(value)) {
    return value;
  }

  const base = String(apiBaseUrl || '').trim();
  if (!base) {
    return value;
  }

  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  const normalizedValue = value.startsWith('/') ? value.slice(1) : value;
  return `${normalizedBase}${normalizedValue}`;
};
